import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import PlantApi from "../../services/PlantApi";

// Design System
import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const PlantDetails: React.FC = () => {
  const { t: translateForm } = useTranslation("form");
  const { t: translateGeneral } = useTranslation("general");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  const [name, setName] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      navigate("/plants");
      return;
    }

    const fetchPlant = async (plantId: string): Promise<void> => {
      try {
        const resp = await PlantApi.GetPlantById(plantId);
        if (resp.success && resp.data) {
          const plant = resp.data;
          setName(plant.name || "");
          setCompanyName(plant.company?.name || plant.companyName || "—");
        }
      } catch (err: any) {
        displayToast("error", translateForm("error"), err.message || "", false, 3000);
        navigate("/plants");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlant(id);
  }, [id, navigate, displayToast, translateForm]);

  const handleBack = (): void => {
    navigate("/plants");
  };

  if (isLoading) {
    return <div className="p-4">{translateGeneral("loading")}...</div>;
  }

  return (
    <FormCard
      title={translateForm("plantDetails")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translateForm("back") || "Voltar"}
      numColumns={12}
      disabled
    >
      {/* Empresa */}
      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("company") || "Empresa"}
          value={companyName}
          onChange={() => {}}
          disabled
        />
      </div>
      
      {/* Nome da Planta */}
      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("name") || "Nome da Planta"}
          value={name}
          onChange={() => {}}
          disabled
        />
      </div>
    </FormCard>
  );
};

export default PlantDetails;


